import React from 'react';
import classNames from 'classnames/bind';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

interface IContentContainerProps {
  children?: React.ReactNode;
  className?: string;
}

export const ContentContainer: React.FC<IContentContainerProps> = ({ children, className }) => (
  <div className={cx('content', className)}>{children}</div>
);
